import React from 'react';

const Footer = () => (
  <footer className="flex items-center justify-end bg-brand px-4 py-1.5 text-[15px] text-white">
    <span className="opacity-75">© {new Date().getFullYear()} Jonas Dormaels</span>
  </footer>
);

export default Footer;
